import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";


const firebaseConfig = {
    apiKey: "AIzaSyAWogvBAk2qVea5WuUu2vSvbSylqMUn2Js",
    authDomain: "desc-sales.firebaseapp.com",
    projectId: "desc-sales",
    storageBucket: "desc-sales.appspot.com",
    messagingSenderId: "445997170234",
    appId: "1:445997170234:web:6ce2ed01134a8ee7a73f03",
    measurementId: "G-JQXH5P76H1"
  };
  
  // Initialize Firebase
  const app = initializeApp(firebaseConfig);
  const analytics = getAnalytics(app);
  if(analytics){}
  const db = getFirestore(app);

  export {db};